import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('Client')
export class Client {
     @JsonProperty('id')
     id = 0;

     @JsonProperty('name')
     name = '';

     @JsonProperty('password',String,true)
     password = '';

     @JsonProperty('username',String,true)
     username = '';

     @JsonProperty('token',String,true)
     token = '';

     @JsonProperty('accessStatus')
     accessStatus = false;

     @JsonProperty('registeredDate',String,true)
     registeredDate = '';

     @JsonProperty('startDate',String,true)
     startDate = '';

     @JsonProperty('endDate',String,true)
     endDate = '';


     constructor() {

    }
}
